import { render, staticRenderFns } from "./ListNotifications.vue?vue&type=template&id=493c4434"
import script from "./ListNotifications.vue?vue&type=script&lang=ts"
export * from "./ListNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports